<template>
    <div>
        <steps :currentStep="currentStep" @switchStep="switchStep"></steps>

        <div class="new-product">
            <div class="my-4">
                <div v-if="step === currentStep">
                    <form @submit.prevent.stop="readyToSave" novalidate @input="productAcivateUpdateFlag('schedule')">
                        <div class="d-flex justify-content-end align-items-center border-bottom-light my-4 p-4">
                            <button type="button" class="btn blue wider mr-3" :disabled="$v.form.$invalid || isEditingAGroup" @click="prevStep"><i class="ico-arrow-left fs-normal ml-2"></i> Back</button>
                            <button type="button" class="btn cancel wider mr-3" @click="cancel">Cancel</button>
                            <button type="button" class="btn green wider mr-3" :disabled="$v.form.$invalid || isEditingAGroup" @click="readyToSave" v-if="getSelectedItem !== null">Save</button>
                            <button type="button" class="btn blue wider" :disabled="$v.form.$invalid || isEditingAGroup" @click="nextStep">Next <i class="ico-arrow-right fs-normal ml-2"></i></button>
                        </div>

                        <div class="px-4">

                            <div class="topScheduleOptionsHolder d-flex mb-5">
                                <div class="availabilityHolder d-flex flex-grow-1">
                                    <div class="panel mt-0">
                                        <h5>Availability - How to manage your resources availability.</h5>
                                        <div class="scheduleTypeHolder d-flex mt-2">
                                            <button type="button" class="btn tertiary" :class="{'selected': form.availabilityType == availabilityType.value}" v-for="availabilityType in getAvailabilityTypes" @click="setAvailabiltyType(availabilityType)">{{availabilityType.label}}</button>

                                            <div class="ml-2" style="width: 180px;" v-if="form.availabilityType == 0">
                                                <label class="w-100">Max. availability</label>
                                                <input type="number" style="width: 70px;" v-model="form.capacity" @input="$v.form.capacity.$touch, productAcivateUpdateFlag('scheduleAvailability')">

                                                <div v-if="$v.form.capacity.$invalid" class="messages color-6">
                                                    <span v-if="!$v.form.capacity.required">Please set max availability.</span>
                                                    <span v-if="!$v.form.capacity.customRequired"></span>
                                                </div>
                                            </div>
                                        </div>


                                    </div>
                                </div>


                                <div class="virtualRooster d-flex">
                                    <!-- Virtual Rooster -->
                                    <div class="panel mt-0 d-flex flex-column flex-grow-1">
                                        <h5>Virtual Roster</h5>

                                        <div class="w-100 d-flex flex-row">

                                            <div class="d-flex mr-2 pt-1">
                                                <checkbox v-model="virtualRooster"></checkbox>
                                            </div>

                                            <div class="d-flex flex-column flex-grow-1">
                                                <div class="w-100 ">Do not allocate resources to this activity until the first booking in made. </div>
                                                <div class="w-100 dark">
                                                    This allows you to share resources between different products on a first-come, first-served basis. <a class="color-1 underlined pointer" href="https://intercom.help/pluralo/pt/articles/3215564" target="_blank">know more</a>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div class="row">
                                <div class="col-sm-12">
                                    <div class="d-flex justify-content-between mb-2">
                                        <label class="mb-2">Schedule - Specify dates and hours for your activities.</label>
                                        <button class="btn tertiary" v-if="form.id" :disabled="getIsDownloadingOldGroups" type="button" @click="togglePastGroups">{{hidePastGroups? 'Show':'Hide'}} older schedules</button>
                                    </div>
                                    <!-- <div class="panel shaded mt-1 pt-0"> -->

                                        <div class="form-group row" v-if="isSpecial">
                                            <div class="col-sm-6">
                                                <table class="table narrow">
                                                    <thead>
                                                        <tr>
                                                            <th class="pl-3">Date</th>
                                                            <th class="pl-3">Starts</th>
                                                            <th class="pl-3">&nbsp;</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                        <tr v-for="(schedule, index) in form.schedules">
                                                            <td class="pl-3">
                                                                <input type="date" v-model="schedule.dateFrom">
                                                            </td>
                                                            <td class="pl-3">
                                                                <timepicker
                                                                    @change="setStartTime($event, schedule)"
                                                                    :defaultTime="fetchDefaultScheduleStartTime(schedule)"
                                                                    :availableHours="durationHourSlots">
                                                                </timepicker>
                                                                <!-- <input type="time" v-model="schedule.startTime" step="1"> -->
                                                            </td>
                                                            <td class="pl-3">
                                                                <i v-if="index > 0" class="ico-delete largest medium" @click="deleteItem(index, 'schedules', schedule)"></i>
                                                            </td>
                                                        </tr>
                                                    </tbody>
                                                </table>

                                                <div class="add d-flex align-items-center pointer fs-small bold mt-5" @click="addScheduleSpecial">
                                                    <i class="ico-add fs-smallest add-circle color-1"></i> Add new
                                                </div>
                                            </div>
                                        </div>

                                        <div v-else>

                                            <div v-if="filteredGroups.length > 0" class="form-group schedule d-flex bg-lightest" v-for="(group, index) in filteredGroups">


                                                <div class="row w-100 pt-1 pl-3 pb-1 pr-0">

                                                    <div class="col-sm-12 my-2 d-flex justify-content-between align-items-center">
                                                        <div>
                                                            <input type="text" class="bg-lightest" style="width: 450px;" v-model="group.label" placeholder="Schedule name" :disabled="!group.isEditing || group.isEditing == false">
                                                            <span class="fs-small dark ml-2" v-if="group.isEdited && group.isEdited == true">edited</span>
                                                        </div>
                                                        <div class="d-flex align-items-center">
                                                            <span class="bold darker fs-small mx-3 pointer" v-if="!group.readOnly" @click="duplicateRow(group)">Duplicate</span>
                                                            <span class="bold darker fs-small mx-3 pointer" v-if="!group.readOnly" @click="deleteItem(index, 'groups', group)">Delete</span>
                                                            <div v-if="!isCreatingProduct && !group.readOnly">
                                                                <span class="bold darker fs-small mx-3 pointer" v-if="!group.isEditing || group.isEditing == false" @click="editGroupToggle(group)">{{(group.isEditing && group.isEditing)? 'Editing':'Edit'}}</span>
                                                                <button class="btn tertiary mx-3" type="button" v-if="group.isEditing && group.isEditing == true" @click="cancelEditGroup(group, index)">Cancel</button>
                                                                <button class="btn primary mx-3" type="button" v-if="group.isEditing && group.isEditing == true" @click="editGroupToggle(group)">Submit</button>
                                                            </div>
                                                            <!-- <i v-if="form.groups.length > 1" class="ico-delete largest medium pointer mx-2" @click="deleteItem(index, 'groups')"></i> -->
                                                            <i class="ico mx-0 fs-normal pointer" :class="{'ico-arrow-top':group.expanded, 'ico-arrow-bottom':!group.expanded}" @click="toggleGroupExpanded(group)"></i>
                                                        </div>
                                                    </div>

                                                    <div v-if="group.expanded" class="col-md-6">
                                                            <div class="col-sm-12 panel shaded mt-0 mb-3">

                                                                <!--  -->
                                                                <!-- GROUP DATES HERE  -->
                                                                <!--  -->
                                                                <product-schedule-group-time-dates v-bind:group.sync="group" :form="form" @update="productAcivateUpdateFlag('schedule')"/>

                                                            </div>
                                                    </div>

                                                    <div v-if="group.expanded" class="col-md-6 pb-3">
                                                        <div class="row">

                                                            <div class="col-sm-12">
                                                                <div class="panel shadded mt-0">

                                                                    <div class="d-flex pb-3 mb-3 border-bottom-light justify-content-between align-items-center pointer" @click="toggleExpand(group)">
                                                                        <span class="font-weight-600">PRICES</span>
                                                                        <i class="ico mx-0 fs-normal" :class="{'ico-arrow-top':group.pricesExpanded, 'ico-arrow-bottom':!group.pricesExpanded}"></i>
                                                                    </div>

                                                                    <div class="panelHolder" style="max-height: none;" :class="{closed: !group.pricesExpanded}">

                                                                        <pricing-manager class="panel mt-0" :disabled="!group.isEditing || group.isEditing == false" :group="group" v-model="group.productGenderPrices"></pricing-manager>

                                                                    </div>

                                                                </div>
                                                            </div>

                                                            <div class="col-sm-12">
                                                                <resources-manager class="panel shaded" :disabled="!group.isEditing || group.isEditing == false" :readOnly="group.readOnly" :form="form" :group="group"></resources-manager>
                                                            </div>

                                                        </div>

                                                    </div>

                                                    <!-- Group Changes -->
                                                    <!-- <schedule-group-changes v-if="true" :group="group" /> -->

                                                </div>

                                                <div class="px-2 py-3 text-center">

                                                </div>

                                            </div>

                                            <div v-if="filteredGroups.length == 0" class="d-flex flex-column">
                                                <span class="dark fs-large w-100 text-center">Looks like you have no active schedules, feel free to <b @click="addGroup" class="pointer">add a new one</b>!</span>
                                                <span v-if="pastGroups.length > 0" class="dark fs-small w-100 text-center">You have {{pastGroups.length}} older schedule{{pastGroups.length > 1? 's':''}} that are hidden, <b @click="togglePastGroups" class="pointer">show all</b></span>
                                            </div>

                                            <button class="btn tertiary" type="button" @click="addGroup">
                                                <i class="ico-add fs-smallest add-circle color-1"></i> Add new schedule
                                                <!-- <div class="add d-flex align-items-center pointer fs-small bold mt-5" @click="addGroup">
                                                </div> -->
                                            </button>

                                        </div>
                                    <!-- </div> -->

                                </div>

                            </div>
                        </div>

                        <div class="d-flex justify-content-end align-items-center border-bottom-light my-4 p-4">
                            <button type="button" class="btn blue wider mr-3" :disabled="$v.form.$invalid || isEditingAGroup" @click="prevStep"><i class="ico-arrow-left fs-normal ml-2"></i> Back</button>
                            <button type="button" class="btn cancel wider mr-3" @click="cancel">Cancel</button>
                            <button type="button" class="btn green wider mr-3" :disabled="$v.form.$invalid || isEditingAGroup" @click="readyToSave" v-if="getSelectedItem !== null">Save</button>
                            <button type="button" class="btn blue wider" :disabled="$v.form.$invalid || isEditingAGroup" @click="nextStep">Next <i class="ico-arrow-right fs-normal ml-2"></i></button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ProductScheduleGroupTimeDates from './components/ProductScheduleGroupTimeDates.vue'

    import { mapGetters, mapActions } from 'vuex'
    import extendedVSelect from '@/extends/vue-select'
    import Timepicker from '@/tools/Timepicker'
    import Steps from './ProductSteps'
    import { required, withParams, numeric } from 'vuelidate/lib/validators'
    import Datepicker from 'vuejs-datepicker';
    import ResourcesManager from './components/ResourcesManager'
    import PricingManager from './components/PricingManager'
    import WeekDayPicker from './components/WeekDayPicker'
    import DurationPicker from './components/DurationPicker'
    import DatePickerNew from 'vue-date'

    // show changes made to groups
    import scheduleGroupChanges from './components/scheduleGroupChanges.vue'

    // mixins
    import {productMixin} from '@/mixins/product'

    export default {
        mixins: [
            productMixin
        ],
        props: {
            currentStep: Number,
        },
        data: function() {
            return {
                teste: [],
                step: 2,
                isSpecial: false,
                showCapacity: true,
                form: {
                    isPrivate: false,
                    schedules: [],
                },
                groupChanges: [],
                selectedType: null,
                defaultDuration: ['02', '00'],
                defaultScheduleStartTime: ['10', '00'],
                durationHourSlots: null,

                hidePastGroups: true,
                loadedPastGroups: false,
                pastGroups: [],
            }
        },
        validations: {
            form: {
                capacity: {
                    numeric,
                    customRequired: function() {
                        return this.maxAvailabilityCheck()
                    }
                },
            }
        },
        created: function() {
            this.form = JSON.parse(JSON.stringify(this.getClonedItem));

            if (this.getSelectedItem) {
                this.toggleCapacity();
                //turns old product versions to the new version:
                if(!this.form.version || this.form.version == 0){
                    this.$set(this.form, 'version', 1)
                }

            } else {
                if(this.form.groups === undefined || this.form.groups.length == 0){
                    this.addGroup();
                }
            }


            // this.buildDatesAndTimes();


            // if we dont have a availabilityType we will set it as 0
            if(!this.form.availabilityType){
                this.$set(this.form, 'availabilityType', 0)
            }

        },
        computed: {
            ...mapGetters([
                'getSelectedItem',
                'getClonedItem',
                'account',
                'getAvailabilityTypes',
                'getIsDownloadingOldGroups',
                'getAudienceTypeList',
            ]),
            isEditingAGroup: function () {
                if(!this.form || !this.form.groups || this.form.groups.length == 0 || this.isCreatingProduct){
                    return false
                } else {
                    return this.form.groups.find(group => group.isEditing) !== undefined
                }
            },
            virtualRooster: {
                get: function () {
                    return this.form.productShareType == 2
                },
                set: function (val) {
                    this.form.productShareType = val? 2 : 0
                }
            },
            isCreatingProduct: function () {
                return this.getSelectedItem == null
            },
            // pastGroups: function () {
            //     let groupsArray = this.form.groups.filter(group => {
            //         // keep groups whith ending date before today that have ID (saved ones)
            //         return moment().subtract(1, 'day').isAfter(group.dateTo) && group.id != null
            //     })
            //
            //     groupsArray.map(group => {
            //         // this.$set(group, 'readOnly', true)
            //     })
            //
            //
            //     return groupsArray
            // },
            activeGroups: function () {
                return this.form.groups.filter(group => {
                    // keeps groups with ending date after or today or have no ID (not saved)
                    return moment().isBefore(group.dateTo) || group.id == null
                })
            },
            allGroups: function () {
                // return this.pastGroups.concat(this.activeGroups)
                return this.form.groups
            },
            filteredGroups: function () {
                if(this.hidePastGroups == true){
                    return this.activeGroups
                } else {
                    return this.allGroups
                }
            }
        },
        methods: {
            ...mapActions([
                'getOldGroups'
            ]),
            togglePastGroups: function () {
                if(this.loadedPastGroups == false){
                    // download old groups
                    this.getOldGroups({
                        reservationId: this.form.id
                    }).then(response => {
                        console.log('this.form 1', this.form);
                        this.$set(this.form, 'groups', this.form.groups.concat(response))
                        this.$emit('updateBackupGroup', response)
                        // this.pastGroups = response
                        this.loadedPastGroups = true
                        console.log('this.form 2', this.form);
                    })
                }
                this.hidePastGroups = !this.hidePastGroups
            },
            backupExistingGroups: function () {
                let groups = this.form.groups
                if(groups.length > 0 && !groups[0].backupGroup) {
                    groups.map(group => {
                        group.backupGroup = JSON.parse(JSON.stringify(group))
                    })
                }
            },
            backupSpecificGroup: function (group){
                let groupBackup = JSON.parse(JSON.stringify(group))

                // remove previous backup from backup
                if(groupBackup.backupGroup){
                    delete groupBackup.backupGroup
                }

                this.$set(group, 'backupGroup', groupBackup)
            },
            updateScheduleType: function() {
                this.form.type = this.selectedType.id || null;
                this.isSpecial = (this.selectedType.id === 2) ? true : false;
                this.schedules = [];
            },
            addGroup: function() {
                this.productAcivateUpdateFlag('schedule')
                if (this.form.groups === undefined) {
                    this.$set(this.form, 'groups', []);
                }

                this.form.groups.push(this.createEmptyGroupRow());
            },
            addScheduleSpecial: function() {
                if (this.form.schedules === undefined) {
                    this.$set(this.form, 'schedules', []);
                }

                this.form.schedules.push(this.createEmptyScheduleSpecialRow());
            },
            createEmptyGroupRow: function() {
                let emptyGroup = {
                    id: null,
                    expanded: true,
                    isEditing: true,
                    version: 1,
                    label: 'Group '+(this.form.groups.length + 1),
                    description: null,
                    shareType: 0,
                    tax: true, //price includes taxes
                    dateFrom: this.nowDate(),
                    dateTo: this.nowDate(),
                    pricesExpanded: false,
                    resourcesExpanded:false,
                    schedules: [this.empty_schedule()],
                    components: [],
                    productGenderPrices: [this.empty_price()],
                    resources: [],
                    duration: this.defaultDuration[0]+':'+this.defaultDuration[1]+":00",
                };

                emptyGroup.backupGroup = JSON.parse(JSON.stringify(emptyGroup))

                return emptyGroup
            },
            addRepetition: function(group) {
                if(!group.isEditing || group.isEditing == false){
                    return false
                }

                let lastScheduleFromGroup = JSON.parse(JSON.stringify(group.schedules[group.schedules.length - 1]))
                lastScheduleFromGroup.id = null
                group.schedules.push(lastScheduleFromGroup)
            },
            removeSchedule: function(group, index, schedule) {
                if(!group.isEditing || group.isEditing == false && (schedule.id && schedule.id  !== null)){
                    return false
                }

                if(group.schedules.length == 1){
                    this.$dialog.alert('\
                    <div class="fs-larg font-weight-600 mb-4">Unable to delete this schedule.</div>\
                    <div>You need to have at least one repetition, if you need to delete this one please create another one before.</div>', {
                        okText:'Ok'
                    })
                    .then(function () {

                    })
                    .catch(function () {
                    });
                    return false
                }

                this.$dialog.confirm('\
                <div class="fs-larg font-weight-600 mb-4">Delete schedule?</div>\
                <div>If this schedule has any reservations, those will <span class="underlined bold color-6">be canceled!</span></div>')
                .then(function () {
                    group.schedules.splice(index, 1)
                    this.$set(group, 'schedules', group.schedules)
                })
                .catch(function () {
                });

            },
            empty_schedule: function() {
                return {
                    startTime: this.defaultScheduleStartTime[0]+':'+this.defaultScheduleStartTime[1]+":00",
                    repeatsAtWeekDays: []
                }
            },
            empty_price: function() {
                return {
                    currency: "€",
                    value: 0,
                    vatType: 0,
                    genderPriceType: 1,
                    isTaxIncludedInPrice: true,
                    isExcludedFromBilling: false,
                    productGenderPriceComponents: [],
                }
            },
            createEmptyScheduleSpecialRow: function() {
                return {
                    id: 0,
                    dateFrom: this.nowDate(),
                    startTime: '',
                };
            },
            deleteItem: function(row, deleteType, item) {
                //if this is the last group we don't delete it
                // if(this.form.groups.length == 1){
                //     this.$dialog.alert('\
                //     <div class="fs-larg font-weight-600 mb-4">Unable to delete this group.</div>\
                //     <div>You need to have at least one group, if you need to delete this one please create another one before.</div>', {
                //         okText:'Ok'
                //     })
                //     .then(function () {
                //
                //     })
                //     .catch(function () {
                //     });
                //     return false
                // }



                // Deletes selected row
                // works for resources and schedules
                let vm = this

                switch (deleteType) {
                    case 'groups':
                        this.$dialog.confirm('\
                        <div class="fs-larg font-weight-600 mb-4">Delete schedule group?</div>')
                    	.then(function () {
                            // vm.deleteItem(index, 'groups')
                            // vm.form.groups.splice(row, 1)
                            // find if is an old or a new group
                            var isOldGroup = true

                            if(typeof vm.pastGroups == "undefined" || vm.pastGroups == null || vm.pastGroups.length == 0){
                                isOldGroup = false
                            } else {
                                if(vm.pastGroups.find(pastGroup => {return pastGroup.id == item.id}) == undefined){
                                    isOldGroup = false
                                } else {
                                    isOldGroup = true
                                }

                            }

                            let groupArray
                            if(isOldGroup == true){
                                groupArray = vm.pastGroups
                            } else {
                                groupArray = vm.form.groups
                            }


                            let index = groupArray.indexOf(item)
                            vm.$delete(groupArray, index)

                            this.productAcivateUpdateFlag('schedule')
                            console.log('datesChanged', dates, group);
                    	})
                    	.catch(function () {
                    	});

                        break

                    default:
                        break;
                }
            },
            duplicateRow: function (row) {
                this.productAcivateUpdateFlag('schedule')
                let copiedRow = JSON.parse(JSON.stringify(row))

                // adds 'Copy string to group label'
                if(!copiedRow.label.startsWith('(Copy)')){
                    copiedRow.label = '(Copy) '+ copiedRow.label
                }

                if(copiedRow.id){
                    copiedRow.id = null
                }

                this.form.groups.push(
                    copiedRow
                )
            },
            editGroupToggle: function(group){
                this.productAcivateUpdateFlag('schedule')

                if(!group.isEditing){
                    this.$set(group, 'isEditing', true)
                    this.$set(group, 'expanded', true)
                    // this.$set(group, 'backupGroup', JSON.parse(JSON.stringify(group)))
                    // creates a copy of each gruop
                    this.backupExistingGroups()
                    this.backupSpecificGroup(group)
                } else {



                    if(group.isEditing == false){
                        this.$set(group, 'isEditing', true)
                        this.$set(group, 'expanded', false)
                        this.backupSpecificGroup(group)
                    } else {

                        // check for changes on weekdays - if there were removed days we will show a warning, if the user
                        // presses ok -> everything will proceed, if press Cancel -> Weekdays revert back and submit is canceled

                        let showWeekdaysWarning = false
                        for (let schedule of group.schedules) {
                            let backupSchedule = group.backupGroup.schedules.find(backupScheduleItem => backupScheduleItem.id == schedule.id)

                            if(backupSchedule){

                                // repeatsAtWeekDays
                                let removedWeekDays = backupSchedule.repeatsAtWeekDays.filter(backupWkDay => {
                                    return schedule.repeatsAtWeekDays.filter(currentWkDay => {return currentWkDay == backupWkDay}).length == 0
                                })

                                if(removedWeekDays.length > 0){
                                    showWeekdaysWarning = true
                                }
                            }
                        }

                        if(showWeekdaysWarning == true){
                            this.$dialog.confirm('One or more days of the week were removed.<br>Some events might be lost, proceed?', {
                                okText: 'Yes', cancelText: 'No'
                            }).then(() => {
                                // check what changed on this schedule
                                this.checkScheduleChanges(group)

                                this.$set(group, 'isEditing', false)
                                this.$set(group, 'isEdited', true)
                                this.$set(group, 'expanded', false)

                            }).catch(() => {
                                //resets schedules
                                group.schedules = JSON.parse(JSON.stringify(group.backupGroup.schedules))

                            });
                        } else {
                            // check what changed on this schedule
                            this.checkScheduleChanges(group)

                            this.$set(group, 'isEditing', false)
                            this.$set(group, 'isEdited', true)
                            this.$set(group, 'expanded', false)

                        }


                    }
                }
            },
            tagProductToShowApplyAllEvents: function (group, reason) {
                if(group.id == null){
                    return false
                }
                console.log('tagProductToShowApplyAllEvents', reason);
                this.$set(this.form, 'showApplyAllEventQuestion', true)
            },
            checkScheduleChanges: function (group) {
                // ----------------- root group changes ---------------------
                let rootEditedFields = group.editedFields == undefined ? [] : group.editedFields;
                let genderPriceEditedFields = group.editedFieldsGenderPrice == undefined ? [] : group.editedFieldsGenderPrice;
                let resourcesEditedFields = [];
                let shcedulesEditedFields = group.editedFieldsSchedules == undefined ? [] : group.editedFieldsSchedules;

                // label
                if(group.label !== group.backupGroup.label){
                    this.tagProductToShowApplyAllEvents(group,'Label')
                    this.pushChangeToArray(
                        rootEditedFields,
                        'Label',
                        'label',
                        group.backupGroup.label,
                        group.label,
                        group.backupGroup.label,
                        group.label,
                    )
                }

                // duration
                if(group.duration !== group.backupGroup.duration){
                    this.tagProductToShowApplyAllEvents(group,'Duration')
                    this.pushChangeToArray(
                        rootEditedFields,
                        'Duration',
                        'duration',
                        group.backupGroup.duration.slice(0, 5),
                        group.duration.slice(0, 5),
                        group.backupGroup.duration,
                        group.duration,
                    )
                }

                // isTaxIncludedInPrice
                if(group.productGenderPrices[0] && group.productGenderPrices[0].isTaxIncludedInPrice != group.backupGroup.productGenderPrices[0].isTaxIncludedInPrice){
                    this.tagProductToShowApplyAllEvents(group,'Tax excluded from price')
                    this.pushChangeToArray(
                        rootEditedFields,
                        'Tax excluded from price',
                        'isTaxIncludedInPrice',
                        group.backupGroup.productGenderPrices[0].isTaxIncludedInPrice?'Yes':'No',
                        group.productGenderPrices[0].isTaxIncludedInPrice?'Yes':'No',
                        group.backupGroup.productGenderPrices[0].isTaxIncludedInPrice,
                        group.productGenderPrices[0].isTaxIncludedInPrice,
                    )
                }

                // genderPriceType
                if(group.productGenderPrices[0] && group.productGenderPrices[0].genderPriceType != group.backupGroup.productGenderPrices[0].genderPriceType){
                    this.tagProductToShowApplyAllEvents(group,'Ticket type')
                    this.pushChangeToArray(
                        rootEditedFields,
                        'Ticket type',
                        'productGenderPrices',
                        group.backupGroup.productGenderPrices[0].genderPriceType == 1 ?'Per Order':'Per Person',
                        group.productGenderPrices[0].genderPriceType == 1 ?'Per Order':'Per Person',
                        group.backupGroup.productGenderPrices[0].productGenderPrices,
                        group.productGenderPrices[0].productGenderPrices,
                    )
                }

                // dateFrom
                if(group.dateFrom != group.backupGroup.dateFrom){
                    this.pushChangeToArray(
                        rootEditedFields,
                        'Starting date',
                        'dateFrom',
                        group.backupGroup.dateFrom,
                        group.dateFrom,
                        group.backupGroup.dateFrom,
                        group.dateFrom,
                    )
                }

                // dateTo
                if(group.dateTo != group.backupGroup.dateTo){
                    this.pushChangeToArray(
                        rootEditedFields,
                        'Ending date',
                        'dateTo',
                        group.backupGroup.dateTo,
                        group.dateTo,
                        group.backupGroup.dateTo,
                        group.dateTo,
                    )
                }

                // shareType
                if(group.shareType != group.backupGroup.shareType){
                    this.tagProductToShowApplyAllEvents(group,'Resource sharing')
                    this.pushChangeToArray(
                        rootEditedFields,
                        'Resource sharing',
                        'shareType',
                        group.backupGroup.shareType == 0?'No':'Yes',
                        group.shareType == 0?'No':'Yes',
                        group.backupGroup.shareType,
                        group.shareType,
                    )
                }

                this.$set(group, 'editedFields', rootEditedFields)


                // ----------------- productGenderPrices ---------------------
                for (let genderPrice of group.productGenderPrices) {

                    let genderPriceChangesArray = []

                    let backupGenderPrice = group.backupGroup.productGenderPrices.find(backupGenderPriceItem => backupGenderPriceItem.id == genderPrice.id)

                    // Exists a backupGenderPrice
                    if(backupGenderPrice){


                        // Gender Price Type
                        if(genderPrice.genderPriceType != backupGenderPrice.genderPriceType){
                            this.tagProductToShowApplyAllEvents(group,'Price')
                            this.pushChangeToArray(
                                genderPriceChangesArray,
                                'Price',
                                'genderPriceType',
                                backupGenderPrice.genderPriceType+'€',
                                genderPrice.genderPriceType+'€',
                                backupGenderPrice.genderPriceType,
                                genderPrice.genderPriceType,
                            )
                        }

                        // Label
                        if(genderPrice.audienceTypeLabel != backupGenderPrice.audienceTypeLabel){
                            this.tagProductToShowApplyAllEvents(group,'Label')
                            this.pushChangeToArray(
                                genderPriceChangesArray,
                                'Label',
                                'audienceTypeLabel',
                                backupGenderPrice.audienceTypeLabel,
                                genderPrice.audienceTypeLabel,
                                backupGenderPrice.audienceTypeLabel,
                                genderPrice.audienceTypeLabel,
                            )
                        }

                        // audienceTypeOccupancy
                        if(genderPrice.audienceTypeOccupancy != backupGenderPrice.audienceTypeOccupancy){
                            this.tagProductToShowApplyAllEvents(group,'Occupancy')
                            this.pushChangeToArray(
                                genderPriceChangesArray,
                                'Occupancy',
                                'audienceTypeOccupancy',
                                backupGenderPrice.audienceTypeDescription,
                                genderPrice.audienceTypeDescription,
                                backupGenderPrice.audienceTypeOccupancy,
                                genderPrice.audienceTypeOccupancy,
                            )
                        }

                        // vatType
                        if(genderPrice.vatType != backupGenderPrice.vatType){
                            this.tagProductToShowApplyAllEvents(group,'Vat type')
                            this.pushChangeToArray(
                                genderPriceChangesArray,
                                'Vat type',
                                'vatType',
                                backupGenderPrice.vatType+'%',
                                genderPrice.vatType+'%',
                                backupGenderPrice.vatType,
                                genderPrice.vatType,
                            )
                        }

                        // isTaxIncludedInPrice
                        // if(genderPrice.isTaxIncludedInPrice != backupGenderPrice.isTaxIncludedInPrice){
                        //     this.pushChangeToArray(
                        //         genderPriceChangesArray,
                        //         'Tax excluded from price',
                        //         'isTaxIncludedInPrice',
                        //         backupGenderPrice.isTaxIncludedInPrice?'Yes':'No',
                        //         genderPrice.isTaxIncludedInPrice?'Yes':'No',
                        //         backupGenderPrice.isTaxIncludedInPrice,
                        //         genderPrice.isTaxIncludedInPrice,
                        //     )
                        // }

                        // genderPriceType
                        if(genderPrice.audienceType != backupGenderPrice.audienceType){
                            this.tagProductToShowApplyAllEvents(group,'Audience')
                            this.pushChangeToArray(
                                genderPriceChangesArray,
                                'Audience',
                                'audienceType',
                                backupGenderPrice.audienceTypeDescription,
                                genderPrice.audienceTypeDescription,
                                backupGenderPrice.audienceType,
                                genderPrice.audienceType,
                            )
                        }

                        // value
                        if(genderPrice.value != backupGenderPrice.value){
                            this.tagProductToShowApplyAllEvents(group,'Price')
                            this.pushChangeToArray(
                                genderPriceChangesArray,
                                'Price',
                                'value',
                                backupGenderPrice.value+'€',
                                genderPrice.value+'€',
                                backupGenderPrice.value,
                                genderPrice.value,
                            )
                        }

                        // productGenderPriceComponents
                        // first check if there are differences
                        let componentDifferences = genderPrice.productGenderPriceComponents.filter(priceComponent => {
                                // returns if priceComponent is not present on backup
                                return backupGenderPrice.productGenderPriceComponents.find(bkpPriceComponent => {return bkpPriceComponent.id == priceComponent.id}) == undefined
                        })

                        if(componentDifferences.length > 0 || genderPrice.productGenderPriceComponents.length < backupGenderPrice.productGenderPriceComponents.length){
                            this.tagProductToShowApplyAllEvents(group,'Price components')
                            this.pushChangeToArray(
                                genderPriceChangesArray,
                                genderPrice.audienceTypeDescription + ' - Number of price components',
                                'productGenderPriceComponents',
                                backupGenderPrice.productGenderPriceComponents.length,
                                genderPrice.productGenderPriceComponents.length,
                                backupGenderPrice.productGenderPriceComponents,
                                genderPrice.productGenderPriceComponents,
                            )
                        }


                        //search if this genderPrice already has changes object
                        let foundGenderPriceChangesObj = group.editedFieldsGenderPrice != undefined ? group.editedFieldsGenderPrice.find(i => i.genderPriceId == genderPrice.id) : false

                        if(foundGenderPriceChangesObj){
                            let index = group.editedFieldsGenderPrice.indexOf(foundGenderPriceChangesObj)

                            group.editedFieldsGenderPrice[index] = {
                                genderPriceId: genderPrice.id,
                                changes:genderPriceChangesArray
                            }

                        } else {
                            // only add if there are any changes, this prevents empty changes array
                            if(genderPriceChangesArray.length > 0){
                                genderPriceEditedFields.push({
                                    genderPriceId: genderPrice.id,
                                    changes:genderPriceChangesArray
                                })
                            }
                        }

                    } else {

                    }
                }
                this.$set(group, 'editedFieldsGenderPrice', genderPriceEditedFields)

                // ----------------- resources ---------------------
                for (var i = 0; i < group.resources.length; i++) {
                    let resource = group.resources[i]

                    let resourcesChangesArray = []

                    let backupResource = group.backupGroup.resources[i]

                    // Exists a backupResource
                    if(backupResource){

                        // Resource Id
                        // if(resource.id != backupResource.id){
                        //     this.tagProductToShowApplyAllEvents(group,'Resource')
                        //     this.pushChangeToArray(
                        //         resourcesChangesArray,
                        //         'Resource',
                        //         'id',
                        //         backupResource.name,
                        //         resource.name,
                        //         backupResource.id,
                        //         resource.id,
                        //     )
                        // }

                        // Max seats
                        if(resource.maxSeats != backupResource.maxSeats){
                            this.tagProductToShowApplyAllEvents(group,'Max. Seats')
                            this.pushChangeToArray(
                                resourcesChangesArray,
                                'Max. Seats',
                                'maxSeats',
                                backupResource.maxSeats,
                                resource.maxSeats,
                                backupResource.maxSeats,
                                resource.maxSeats,
                            )
                        }


                        //search if this resource already has changes object
                        // let foundResourcesChangesObj = group.resourcesEditedFields[i] != undefined ? backupResource : false
                        // let foundResourcesChangesObj = backupResource

                        // if(foundResourcesChangesObj){
                        //     let index = group.resourcesEditedFields.indexOf(foundResourcesChangesObj)
                        //     group.resourcesEditedFields[index] = {
                        //         resourceId: resource.id,
                        //         changes:resourcesChangesArray
                        //     }
                        // } else {
                            resourcesEditedFields.push({
                                resourceId: resource.id,
                                changes:resourcesChangesArray
                            })
                        // }

                    } else {
                    }
                }
                this.$set(group, 'editedFieldsResources', resourcesEditedFields)

                // ----------------- schedules ---------------------
                for (let schedule of group.schedules) {

                    let scheduleshangesArray = []

                    let backupSchedule = group.backupGroup.schedules.find(backupScheduleItem => backupScheduleItem.id == schedule.id)

                    // Exists a backupResource
                    if(backupSchedule){

                        // repeatsAtWeekDays
                        if(this.checkArrayDifference(schedule.repeatsAtWeekDays, backupSchedule.repeatsAtWeekDays).length > 0 || schedule.repeatsAtWeekDays.length != backupSchedule.repeatsAtWeekDays.length){
                            let weekDays = [
                                { id: 1, active:false, name: 'Monday', nameSmall:'Mon',  value: 'M' },
                                { id: 2, active:false, name: 'Tuesday', nameSmall:'Tue',  value: 'T' },
                                { id: 3, active:false, name: 'Wednesday', nameSmall:'Wed',  value: 'W' },
                                { id: 4, active:false, name: 'Thursday', nameSmall:'Thu',  value: 'T' },
                                { id: 5, active:false, name: 'Friday', nameSmall:'Fri',  value: 'F' },
                                { id: 6, active:false, name: 'Saturday', nameSmall:'Sat',  value: 'S' },
                                { id: 0, active:false, name: 'Sunday', nameSmall:'Sun',  value: 'S' },
                            ]

                            let backupWeekDays = backupSchedule.repeatsAtWeekDays.map(w => {
                                return weekDays.find(weekday => weekday.id == w).value
                            })
                            let newWeekDays = schedule.repeatsAtWeekDays.map(w => {
                                return weekDays.find(weekday => weekday.id == w).value
                            })

                            // disabled changes resume: week days
                            // this.pushChangeToArray(
                            //     scheduleshangesArray,
                            //     'Week Days',
                            //     'repeatsAtWeekDays',
                            //     backupWeekDays,
                            //     newWeekDays,
                            //     backupSchedule.repeatsAtWeekDays,
                            //     schedule.repeatsAtWeekDays,
                            // )
                        }

                        // startTime
                        if(schedule.startTime != backupSchedule.startTime){
                            this.tagProductToShowApplyAllEvents(group,'Start hour')
                            this.pushChangeToArray(
                                scheduleshangesArray,
                                'Start hour',
                                'startTime',
                                backupSchedule.startTime.slice(0, 5),
                                schedule.startTime.slice(0, 5),
                                backupSchedule.startTime,
                                schedule.startTime,
                            )
                        }

                        //search if this schedule already has changes object
                        let foundscheduleChangesObj = group.editedFieldsSchedules != undefined ? group.editedFieldsSchedules.find(i => i.scheduleId == schedule.id) : false

                        if(foundscheduleChangesObj){
                            let index = group.editedFieldsSchedules.indexOf(foundscheduleChangesObj)
                            group.editedFieldsSchedules[index] = {
                                scheduleId: schedule.id,
                                changes:scheduleshangesArray
                            }
                        } else {
                            shcedulesEditedFields.push({
                                scheduleId: schedule.id,
                                changes:scheduleshangesArray
                            })
                        }


                    } else {

                    }
                }
                this.$set(group, 'editedFieldsSchedules', shcedulesEditedFields)

                // ************** find removed and added gender types **************
                this.findRemovedAndAddedGenderPrices(group)
                // ************** find removed and added schedules **************
                this.findRemovedAndAddedGenderSchedules(group)
                // ************** find removed and added resources **************
                this.findRemovedAndAddedGenderResources(group)


            },
            findRemovedAndAddedGenderPrices: function (group) {
                //check if group has any backedup gender prices
                let groupHasBackedupGenderPrices = group.backupGroup && group.backupGroup.productGenderPrices && group.backupGroup.productGenderPrices.length > 0

                // if it has we will check if any of them were removed (to add to "removedArray")
                if(groupHasBackedupGenderPrices){
                    for (let bkpGenderPrice of group.backupGroup.productGenderPrices) {
                        let foundInNormalArray = group.productGenderPrices.find(existingGenderPrice => {return existingGenderPrice.id == bkpGenderPrice.id})
                        if(foundInNormalArray == undefined){
                            this.tagProductToShowApplyAllEvents(group,'Price removed')
                            let audienceDescription = this.getAudienceTypeList.find(gp => {return gp.id == bkpGenderPrice.genderPriceType}).description
                            this.pushChangeToArrayRemovedItem(
                                group,
                                'editedFieldsGenderPriceRemoved',
                                audienceDescription,
                                bkpGenderPrice
                            )
                        }
                    }

                }

                // Now we fill the "AddedArray"
                group.editedFieldsGenderPriceAdded = []

                for (let genderPrice of group.productGenderPrices) {
                    if(!genderPrice.id){
                        this.tagProductToShowApplyAllEvents(group,'Price Added')
                        this.pushChangeToArrayAddedItem(
                            group,
                            'editedFieldsGenderPriceAdded',
                            genderPrice.audienceTypeDescription,
                            genderPrice
                        )
                    }
                }
            },
            findRemovedAndAddedGenderSchedules: function (group) {
                //check if group has any backedup schedules
                let groupHasBackedupSchedules = group.backupGroup && group.backupGroup.schedules && group.backupGroup.schedules.length > 0

                // if it has we will check if any of them were removed (to add to "removedArray")
                if(groupHasBackedupSchedules){

                    for (let bkpSchedule of group.backupGroup.schedules) {
                        let foundInNormalArray = group.schedules.find(existingSchedule => {return existingSchedule.id == bkpSchedule.id})

                        if(!foundInNormalArray){
                            this.tagProductToShowApplyAllEvents(group,'Schedule Removed')
                            this.pushChangeToArrayRemovedItem(group, 'editedFieldsSchedulesRemoved', bkpSchedule.startTime, bkpSchedule)
                        }
                    }

                }

                // Now we fill the "AddedArray"
                group.editedFieldsSchedulesAdded = []

                for (let schedule of group.schedules) {
                    if(!schedule.id){
                        this.tagProductToShowApplyAllEvents(group,'Schedule Added')
                        this.pushChangeToArrayAddedItem(
                            group,
                            'editedFieldsSchedulesAdded',
                            schedule.startTime,
                            schedule
                        )
                    }
                }
            },
            findRemovedAndAddedGenderResources: function (group) {
                //check if group has any backedup resources
                let groupHasBackedupResources = group.backupGroup && group.backupGroup.resources && group.backupGroup.resources.length > 0

                // if it has we will check if any of them were removed (to add to "removedArray")
                if(groupHasBackedupResources){

                    for (let bkpResource of group.backupGroup.resources) {
                        let foundInNormalArray = group.resources.find(existingResource => {return existingResource.id == bkpResource.id})

                        if(!foundInNormalArray){
                            this.tagProductToShowApplyAllEvents(group,'Resource Removed')
                            this.pushChangeToArrayRemovedItem(group, 'editedFieldsResourcesRemoved', bkpResource.name, bkpResource)
                        }
                    }

                }

                // Now we fill the "AddedArray"
                group.editedFieldsResourcesAdded = []
                for (let resource of group.resources) {
                    let isResourceAdded = false
                    // there there is any backup
                    if(group.backupGroup.resources.length > 0){
                        for (let bkpResource of group.backupGroup.resources) {

                            let existsOnBackupGroup = group.backupGroup.resources.find(bkpResource => {return bkpResource.id == resource.id})

                            if(!existsOnBackupGroup){
                                isResourceAdded = true
                            }
                        }
                    } else {
                        // else it must be a new resource
                        isResourceAdded = true
                    }

                    if(isResourceAdded === true){
                        this.tagProductToShowApplyAllEvents(group,'Resource Added')
                        this.pushChangeToArrayAddedItem(
                            group,
                            'editedFieldsResourcesAdded',
                            resource.name,
                            resource
                        )
                    }
                }
            },
            checkArrayDifference: function (arrayA, ArrayB) {
                return arrayA.filter(function(x) {
                	// checking second array does not contain element "x"
                	if(ArrayB.indexOf(x) == -1)
                		return true;
                	else
                		return false;
                });
            },
            // Moved to mixin
            // pushChangeToArray: function(receivingArray, niceName, key, oldNiceValue, newNiceValue, oldValue, newValue) {
            //
            //     //check if item already exists on array
            //     let foundRepetition = receivingArray.find(i => i.name == key)
            //
            //     if(foundRepetition){
            //         let repetitionIndex = receivingArray.indexOf(foundRepetition)
            //         receivingArray[repetitionIndex] = {
            //             name: key,
            //             niceName: niceName,
            //             oldNiceValue: oldNiceValue,
            //             newNiceValue: newNiceValue,
            //             oldValue: oldValue,
            //             newValue: newValue
            //         }
            //     } else {
            //         receivingArray.push({
            //             name: key,
            //             niceName: niceName,
            //             oldNiceValue: oldNiceValue,
            //             newNiceValue: newNiceValue,
            //             oldValue: oldValue,
            //             newValue: newValue
            //         })
            //     }
            // },
            pushChangeToArrayAddedItem: function(group, destinationArray, niceName, genderPrice) {


                let foundDestinyArray = group[destinationArray]

                if(!foundDestinyArray){
                    this.$set(group, destinationArray, []);
                }

                // check if item already exists on array
                let foundRepetition = group[destinationArray].find(added => added.item.audienceType == genderPrice.audienceType)

                if(!foundRepetition){
                    group[destinationArray].push({
                        niceName: niceName,
                        type: 'added',
                        item: genderPrice
                    })
                }
            },
            pushChangeToArrayRemovedItem: function(group, destinationArray, niceName, genderPrice) {

                // editedFieldsGenderPriceRemoved

                let foundDestinyArray = group[destinationArray]

                if(!foundDestinyArray){
                    this.$set(group, destinationArray, []);
                }

                // check if item already exists on array
                let foundRepetition = group[destinationArray].find(removed => removed.item.id == genderPrice.id)

                if(!foundRepetition){
                    group[destinationArray].push({
                        niceName: niceName,
                        type: 'removed',
                        item: genderPrice
                    })
                }
            },
            cancelEditGroup: function(group, index){
                if(group.backupGroup){

                    let backedupGroup = JSON.parse(JSON.stringify(group.backupGroup))
                    backedupGroup.isEdited = false
                    backedupGroup.isEditing = false
                    // this.$set(group, backedupGroup)
                    // group.label = backedupGroup.label

                    // replaces the keys of group object with the ones on the backedupGroup
                    Object.keys(backedupGroup).forEach(function(key) {
                        group[key] = backedupGroup[key];
                    });
                } else {
                    this.deleteItem(index, 'groups', group)
                }
            },
            cancel: function() {
                this.$emit('cancelling');
            },
            switchStep: function(step) {
                // Append some root form properties into each schedule item for consistency with the API
                if(this.form.schedules){
                    this.form.schedules.forEach((schedule, index) => {
                        schedule.position = index;
                        schedule.type = this.form.type;
                        schedule.duration = this.form.duration;
                    });
                }

                this.$emit('goToStep', { invalid: this.$v.form.invalid, form: this.form, step: (step !== undefined && !isNaN(step)) ? step : (this.currentStep + 1) });
            },
            nextStep: function(step) {

                // this.form.schedules.forEach((schedule, index) => {
                //     schedule.position = index;
                //     schedule.type = this.form.type;
                //     schedule.duration = this.form.duration;
                // });


                this.$emit('goToStep', { invalid: this.$v.form.invalid, form: this.form, step: (step !== undefined && !isNaN(step)) ? step : (this.currentStep + 1) });
            },
            prevStep: function(step) {
                // Append some root form properties into each schedule item for consistency with the API

                // this.form.schedules.forEach((schedule, index) => {
                //     schedule.position = index;
                //     schedule.type = this.form.type;
                //     schedule.duration = this.form.duration;
                // });

                this.$emit('goToStep', { invalid: this.$v.form.invalid, form: this.form, step: (step !== undefined && !isNaN(step)) ? step : (this.currentStep - 1) });
            },
            readyToSave: function() {
                // Append some root form properties into each schedule item for consistency with the API
                // this.form.schedules.forEach((schedule, index) => {
                //     schedule.position = index;
                //     schedule.type = this.form.type;
                //     schedule.duration = this.form.duration;
                // });

                this.$emit('readyToSave', { invalid: false, form: this.form });
            },
            buildDatesAndTimes: function() {
                // Add default dates if we're creating. When editing we already have dates
                // so we don't need to do anything.
                // We must also set the default duration when creating a new product.


                if (!this.getSelectedItem) {
                    // Duration is not a "time" (no AM nor PM)

                    this.defaultDuration = ['01', '00'];

                    if (this.form.schedules === undefined) {
                        this.form.schedules = [];
                    }

                    this.form.schedules.forEach(schedule => {
                        schedule.dateFrom = this.nowDate();
                        schedule.dateTo = this.nowDate();

                        this.setStartTime('09:00', schedule);
                    });

                    this.setDuration(this.defaultDuration[0] + ':' + this.defaultDuration[1]);
                }
            },
            fetchDefaultScheduleStartTime: function(schedule) {
                if (schedule.startTime !== undefined && schedule.startTime) {
                    // Transform in array and remove seconds

                    let parts = schedule.startTime.split(':');
                    let time = [parts[0], parts[1]];

                    return time;
                }

                return this.defaultScheduleStartTime;
            },
            setDuration: function(timestamp, schedule) {
                schedule.duration = timestamp + ':00';
            },
            setStartTime: function(event, schedule) {
                schedule.startTime = event + ':00';
            },
            toggleCapacity: function() {
                if (this.form.isPrivate) {
                    if(!this.form.capacity || this.form.capacity == null){
                        this.form.capacity = 0;
                    }
                    this.showCapacity = false;
                }
                else {
                    this.showCapacity = true;
                }
            },
            removePrincingAgeRow: function(index) {
                this.form.productGenderPrices.splice(index, 1);
                this.$forceUpdate();
            },
            setAvailabiltyType: function(availabilityType) {
                this.$set(this.form, 'availabilityType', availabilityType.value)
                this.setAvailabiltyOnGroups()
                this.productAcivateUpdateFlag('schedule')
                this.productAcivateUpdateFlag('scheduleAvailability')
            },
            setAvailabiltyOnGroups: function () {
                if(this.form.groups.length > 0){
                    this.form.groups.map(group => {
                        if(!group.availabilityType){
                            this.$set(group, 'availabilityType', "0")
                        }

                        //set group as changed (edited)
                        this.$set(group, 'isEdited', true)

                    })

                }
            },
            toggleGroupExpanded: function (group) {
                if(!group.expanded){
                    this.$set(group, 'expanded', true)
                } else {
                    group.expanded = !group.expanded
                }
            },
            maxAvailabilityCheck: function() {
                if(this.form.availabilityType != 0){
                    return true
                } else {
                    if(this.form.capacity && this.form.capacity > 0){
                        return true
                    } else {
                        return false
                    }
                }
            },
            // -----------------------------------
            // price editor area
            // -----------------------------------
            toggleExpand: function(group) {
                if(!group.pricesExpanded){
                    this.$set(group, 'pricesExpanded', true)
                } else {
                    group.pricesExpanded = !group.pricesExpanded
                }
            },
        },
        components: {
            Steps,
            vSelect: extendedVSelect,
            Timepicker,
            Datepicker,
            ResourcesManager,
            PricingManager,
            WeekDayPicker,
            DurationPicker,
            DatePickerNew,
            ProductScheduleGroupTimeDates,
            scheduleGroupChanges
        }
    }
</script>

<style lang="scss" scoped>
    @import '../../../assets/scss/_variables.scss';

    //schedule type selector
    .scheduleTypeHolder{
        button{
            line-height: normal;
            height: 80px;
            width: 160px;
            margin-right: 0.5rem;

            &.selected{
                border-color: $color-1;
                border-width: 2px;
            }
        }
    }

    input::-webkit-calendar-picker-indicator,
    input::-webkit-inner-spin-button {
        display: inline-flex !important;
    }

    input[type=time]::-ms-clear {
        display: inline-flex !important;
    }

    input[type=time]::-webkit-clear-button {
        display: inline-flex !important;
    }

    .schedule {
        background-color: $lighter;
        border:  1px solid $light;

        input {
            background-color: $lightest;
        }
    }

    li.active {
        background-color: $color-1 !important;
        border-color: $color-1 !important;
        color: $lightest !important;
    }


    //remove schedule
    .removeSchedule{
        position: absolute;
        top: 1.5em !important;
        right: 1em !important;
        z-index: 1;
    }

    .topScheduleOptionsHolder{
        flex-wrap: wrap;

        .availabilityHolder{
            // max-width: 780px;
        }

        .virtualRooster{
            max-width: 487px;
        }
    }

    @media (max-width: 1360px) {
        .availabilityHolder, .virtualRooster{
            max-width: 100% !important;
            width: 100% !important;
            margin-bottom: 1rem;
        }

        .availabilityHolder .panel{
            max-width: 100% !important;
            width: 100% !important;
        }
    }

    .panelHolder{
        max-height: 800px;
        // transition: all 1300ms ease-in-out;
        overflow: visible;

        &.closed{
            max-height: 0 !important;
            overflow: hidden;
        }
    }
</style>



// WEBPACK FOOTER //
// ProductSchedule.vue?44ef5bbe